/* eslint-disable import/no-anonymous-default-export */
import http from "./httpService";
import {
  AnswerdQuestionsProps,
  bonakirNotifications,
  MemberProfile,
  MemberProps,
} from "../typings/member";
import { default as apiConfing } from "../config.json";
import { LocationAutocompleteType } from "../typings/google";
import { AxiosResponse } from "axios";
import { TagProps } from "../typings/tag";
import { EditProfileDataState } from "../typings/editProfile";
import { AdvancedSearchProps } from "../typings/advancedSearch";

const apiUrl = apiConfing.IS_DEVELOPMENT
  ? apiConfing.API_DEVELOPMENT
  : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/Members`;

export const getProfileStatus = (): Promise<AxiosResponse<MemberProps>> => {
  const url = `${apiEndpoint}/GetProfileStatus`;
  return http.get(url);
};

export const getMemberRequiredProfileVerificationAndBlockedStatus =
  (): Promise<any> => {
    const url = `${apiEndpoint}/IsMemberMediaRequierdVerificationOrBLocked`;
    return http.get(url);
  };

export const deleteMemberFootPrint = (memberCode: number): Promise<any> => {
  const url = `${apiEndpoint}/DeleteFootPrint?memberCodeThatVisitedMe=${memberCode}`;
  return http.delete(url);
};

export const getCanMemberSendBounakir = () => {
  const url = `${apiEndpoint}/CanMemberSendBounakir`;
  return http.get(url);
};

export const getMemberPremiumStatus = (premiumFeatureId: number = 0) => {
  const url = `${apiEndpoint}/GetMemberPremiumStatus?premiumFeatureId=${premiumFeatureId}`;
  return http.get(url);
};

export const revokeMemberImageVerficationStatus = () => {
  const url = `${apiEndpoint}/RevokeMemberImageVerficationStatus`;
  return http.put(url);
};

export const deleteMemberPushToken = (memberCode: number) => {
  const url = `${apiEndpoint}/DeleteMemberPushToken?memberCode=${memberCode}`;
  return http.post(url);
};

export const setMemberPushToken = (memberCode: number, token: string) => {
  const url = `${apiEndpoint}/SetMemberPushToken?memberCode=${memberCode}&token=${token}`;
  return http.post(url);
};

export const dontShowCompleteQuestions = (memberCode: number) => {
  const url = `${apiEndpoint}/DontShowCompleteQuestions?memberCode=${memberCode}`;
  return http.put(url);
};

export const getMemberOnlineStatus = (memberCode: number) => {
  const url = `${apiEndpoint}/GetMemberOnlineStatus?memberCode=${memberCode}`;
  return http.get(url);
};

export const deleteMemberMood = (memberCode: number) => {
  const url = `${apiEndpoint}/DeleteMemberMood?memberCode=${memberCode}`;
  return http.get(url);
};

export const getBonakirNotifications = (memberCode: number) => {
  const url = `${apiEndpoint}/GetBonakirNotifications?memberCode=${memberCode}`;
  return http.get(url);
};

export function setQuestionAnswers(
  memberCode: number,
  answerdQuestions: AnswerdQuestionsProps,
) {
  const url = `${apiEndpoint}/setQuestionAnswers?memberCode=${memberCode}`;
  return http.post(url, answerdQuestions);
}

export function updateQuestionAnswers(
  memberCode: number,
  answerdQuestions: AnswerdQuestionsProps,
) {
  const url = `${apiEndpoint}/UpdateQuestionAnswers?memberCode=${memberCode}`;
  return http.post(url, answerdQuestions);
}

export function updateMemberLocation(
  memberCode: number,
  latitude: number,
  longitude: number,
) {
  const url = `${apiEndpoint}/UpdateMemberLocation?memberCode=${memberCode}&latitude=${latitude}&longitude=${longitude}`;
  return http.put(url);
}

export function getTagsForFilter(
  memberCode: number,
): Promise<AxiosResponse<TagProps[]>> {
  const url = `${apiEndpoint}/GetTagsForFilter?memberCode=${memberCode}`;
  return http.get(url);
}

export function getProfileMember(
  myMemberCode: number,
  memberCode: number,
): Promise<AxiosResponse<MemberProfile>> {
  const url = `${apiEndpoint}/GetProfileMember?myMemberCode=${myMemberCode}&memberCode=${memberCode}`;
  return http.get(url);
}

export function getMyMemberDetails(
  memberCode: number,
): Promise<AxiosResponse<MemberProps>> {
  const url = `${apiEndpoint}/GetMyMemberDetails?MemberCode=${memberCode}`;
  return http.get(url);
}

// export function getHomeMembers(memberCode: number, filterBy: any) {
//   const url = `${apiEndpoint}/GetHomeMembers?memberCode=${memberCode}&filterBy=${filterBy}`;
//   return http.get(url);
// }

// export function getHomeMembersByTag(memberCode: number, tagId: number) {
//   const url = `${apiEndpoint}/GetHomeMembersByTag?memberCode=${memberCode}&tagId=${tagId}`;
//   return http.get(url);
// }

export function getHomeMembers(
  memberCode: number,
  filterBy: any,
  page: number,
) {
  const url = `${apiEndpoint}/GetHomeMembers?memberCode=${memberCode}&filterBy=${filterBy}&page=${page}`;
  return http.get(url);
}

export function getHomeMembersByTag(
  memberCode: number,
  tagId: number,
  page: number,
) {
  const url = `${apiEndpoint}/GetHomeMembersByTag?memberCode=${memberCode}&tagId=${tagId}&page=${page}`;
  return http.get(url);
}

export function getBounakirMembers(
  memberCode: number,
  filterBy: number,
  page: number,
) {
  const url = `${apiEndpoint}/GetBounakirMembers?memberCode=${memberCode}&filterBy=${filterBy}&page=${page}`;
  return http.get(url);
}

export function sendDoubleMatchRequest(
  memberCode: number,
  matchMemberCode: number,
  message: string,
  stickerId: number,
) {
  const url = `${apiEndpoint}/SendDoubleMatchRequest?memberCode=${memberCode}&matchMemberCode=${matchMemberCode}
  &reqeust_text=${message}&stickerId=${stickerId}`;
  return http.get(url);
}

// export function sendFirstMeetingMessageRequest(
//   memberCode: number,
//   matchMemberCode: number,
//   message: string,
//   stickerId: number
// ) {
//   const url = `${apiEndpoint}/SendFirstMeetingMessageRequest?memberCode=${memberCode}&matchMemberCode=${matchMemberCode}
//   &reqeust_text=${message}&stickerId=${stickerId}`;
//   return http.get(url);
// }

export function sendFirstMeetingDoubleMatchApproval(
  memberCode: number,
  matchMemberCode: number,
  message: string,
  stickerId: number,
) {
  const url = `${apiEndpoint}/SendFirstMeetingDoubleMatchApproval?memberCode=${memberCode}&matchMemberCode=${matchMemberCode}
  &reqeust_text=${message}&stickerId=${stickerId}`;
  return http.get(url);
}

export function leaveFootPrint(memberCode: number, visitedMemberCode: number) {
  const url = `${apiEndpoint}/LeaveFootPrint?memberCode=${memberCode}&vistiedMemberCode=${visitedMemberCode}`;
  return http.put(url);
}

export function saveAboutMemberDescription(
  memberCode: number,
  description: string,
) {
  const url = `${apiEndpoint}/SaveAboutMemberDescription?memberCode=${memberCode}`;
  return http.post(url, { description });
}

export function getMemberAdvancedSearch(
  memberCode: number,
): Promise<AxiosResponse<AdvancedSearchProps>> {
  const url = `${apiEndpoint}/GetMemberAdvancedSearch?memberCode=${memberCode}`;
  return http.get(url);
}

export function getProfileEditDetails(
  memberCode: number,
): Promise<AxiosResponse<EditProfileDataState>> {
  const url = `${apiEndpoint}/GetProfileEditDetails?memberCode=${memberCode}`;
  return http.get(url);
}

export function blockMember(
  memberCode: number,
  memberToBlockMemberCode: number,
) {
  const url = `${apiEndpoint}/BlockMember?memberCode=${memberCode}&memberToBlockMemberCode=${memberToBlockMemberCode}`;
  return http.put(url);
}

export function updateMemberBirthday(memberCode: number, birthDay: string) {
  const url = `${apiEndpoint}/UpdateMemberBirthday?memberCode=${memberCode}&birthDay=${birthDay}`;
  return http.put(url);
}

export function updateMemberLookingFor(
  memberCode: number,
  memberLookingFor: number[],
) {
  const url = `${apiEndpoint}/UpdateMemberLookingFor?memberCode=${memberCode}`;
  return http.put(url, memberLookingFor);
}

export function updateMemberPersonalStatus(
  memberCode: number,
  personalStatusId: number,
) {
  const url = `${apiEndpoint}/UpdateMemberPersonalStatus?memberCode=${memberCode}&personalStatusId=${personalStatusId}`;
  return http.put(url);
}

export function updateMemberNickName(memberCode: number, nickName: string) {
  const url = `${apiEndpoint}/UpdateNickName?memberCode=${memberCode}&nickName=${nickName}`;
  return http.put(url);
}

export function updatePassword(memberCode: number, newPassword: string) {
  const updatePasswordDto = {
    memberCode,
    newPassword,
  };
  const url = `${apiEndpoint}/UpdatePassword`;
  return http.put(url, updatePasswordDto);
}

export function updateEmailAddress(memberCode: number, newEmail: string) {
  const url = `${apiEndpoint}/UpdateEmailAddress?memberCode=${memberCode}&newEmail=${newEmail}`;
  return http.put(url);
}

export function updateMemberHeight(height: number) {
  const url = `${apiEndpoint}/UpdateHeight?height=${height}`;
  return http.put(url);
}

export function updateMemberLocationPlace(memberCode: number, cityId: number) {
  const url = `${apiEndpoint}/UpdateLocation?memberCode=${memberCode}&cityId=${cityId}`;
  return http.put(url);
}

export function updateSettings(memberCode: number, propertyName: string) {
  const url = `${apiEndpoint}/updateSettings?memberCode=${memberCode}&propertyName=${propertyName}`;
  return http.put(url);
}

export function complaintAboutMember(complaintsRequest: any) {
  const url = `${apiEndpoint}/ComplaintAboutMember`;
  return http.put(url, complaintsRequest);
}

export function resetAdvancedSettings(
  memberCode: number,
): Promise<AxiosResponse<AdvancedSearchProps>> {
  const url = `${apiEndpoint}/ResetMemberAdvancedSearch?memberCode=${memberCode}`;
  return http.get(url);
}

export function updateAdvancedSettings(memberCode: number, data: any) {
  const url = `${apiEndpoint}/UpdateMemberAdvancedSearch?memberCode=${memberCode}`;
  return http.put(url, data);
}

export function sendMailVerifiction(memberCode: number) {
  const url = `${apiEndpoint}/SendMailVerifiction?memberCode=${memberCode}`;
  return http.get(url);
}

export function completeMailVerifiction(memberCode: string) {
  const url = `${apiEndpoint}/CompleteMailVerifiction?memberCode=${memberCode}`;
  return http.put(url);
}

export function getMoreMembersData(url: string) {
  return http.get(url);
}

// PayPlus payment link generation
export const generatePayPlusPaymentLink = (paymentData: any) => {
  const url = `${apiEndpoint}/GeneratePaymentLink`;
  return http.post(url, paymentData);
};

export const savePremiumStatusToMember = (
  memberCode: number,
  dateTimeSelected: Date,
  sentPurchaseEmail: boolean,
) => {
  const formatter = new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const ms = String(dateTimeSelected.getMilliseconds()).padStart(3, "0");
  const formattedDate = `${formatter.format(dateTimeSelected)}.${ms}`;
  const encodedDate = encodeURIComponent(formattedDate);

  const url = `${apiEndpoint}/SavePremiumStatusToMember?memberCode=${memberCode}&dateTimeSelected=${encodedDate}&sentPurchaseEmail=${sentPurchaseEmail}`;
  return http.post(url);
};

export default {
  setQuestionAnswers,
  updateQuestionAnswers,
  updateMemberLocation,
  getTagsForFilter,
  getHomeMembers,
  getBounakirMembers,
  getProfileMember,
  sendDoubleMatchRequest,
  getMyMemberDetails,
  leaveFootPrint,
  saveAboutMemberDescription,
  getMemberAdvancedSearch,
  getHomeMembersByTag,
  blockMember,
  updateMemberBirthday,
  updateMemberLookingFor,
  getProfileEditDetails,
  updateMemberPersonalStatus,
  complaintAboutMember,
  getMoreMembersData,
  updateMemberNickName,
  updateMemberLocationPlace,
  resetAdvancedSettings,
  updateAdvancedSettings,
  sendMailVerifiction,
  completeMailVerifiction,
  generatePayPlusPaymentLink,
  savePremiumStatusToMember,
};
